import React, { useState } from 'react';
import SincronizacaoManualNota from './SincronizacaoManualNota';

const FloatingActionButton = () => {
    const [showSuccessDialog, setShowSuccessDialog] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [showErrorDialog, setShowErrorDialog] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const handleSincronizacaoSucesso = (message) => {
        setSuccessMessage(message || 'Sincronização realizada com sucesso!');
        setShowSuccessDialog(true);
        setTimeout(() => {
            setShowSuccessDialog(false);
        }, 5000);
    };

    const handleSincronizacaoErro = (message) => {
        setErrorMessage(message || 'Erro ao sincronizar nota fiscal');
        setShowErrorDialog(true);
        setTimeout(() => {
            setShowErrorDialog(false);
        }, 5000);
    };

    return (
        <>
            {/* Botão Flutuante */}
            <div className="fixed bottom-6 right-6 z-40">
                <div className="relative group">
                    {/* Usa o componente SincronizacaoManualNota diretamente com aparência flutuante */}
                    <SincronizacaoManualNota 
                        onSuccess={handleSincronizacaoSucesso}
                        onError={handleSincronizacaoErro}
                        isFloating={true}
                    />

                    {/* Tooltip */}
                    <div className="absolute bottom-full right-0 mb-2 px-3 py-1 bg-gray-900 text-white text-sm rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none">
                        Sincronizar Nota Fiscal
                        <div className="absolute top-full right-4 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-900"></div>
                    </div>
                </div>
            </div>

            {/* Modal de Sucesso */}
            {showSuccessDialog && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4">
                        <div className="flex items-center mb-4">
                            <div className="flex-shrink-0">
                                <svg className="w-8 h-8 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                            </div>
                            <div className="ml-3">
                                <h3 className="text-lg font-medium text-gray-900">Sucesso!</h3>
                            </div>
                        </div>
                        <div className="mt-2">
                            <p className="text-sm text-gray-700 whitespace-pre-line">
                                {successMessage}
                            </p>
                        </div>
                        <div className="mt-4">
                            <button
                                onClick={() => setShowSuccessDialog(false)}
                                className="w-full px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors"
                            >
                                OK
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal de Erro */}
            {showErrorDialog && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4">
                        <div className="flex items-center mb-4">
                            <div className="flex-shrink-0">
                                <svg className="w-8 h-8 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                            </div>
                            <div className="ml-3">
                                <h3 className="text-lg font-medium text-gray-900">Erro</h3>
                            </div>
                        </div>
                        <div className="mt-2">
                            <p className="text-sm text-gray-700">
                                {errorMessage}
                            </p>
                        </div>
                        <div className="mt-4">
                            <button
                                onClick={() => setShowErrorDialog(false)}
                                className="w-full px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors"
                            >
                                OK
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default FloatingActionButton;